import { defineStore } from 'pinia'

const DEFAULT_TENANT = '00000000-0000-0000-0000-000000000001'

export interface TenantOption { id: string; name: string; status: string }

export const useTenantStore = defineStore('tenant', {
  state: () => ({ tenantId: localStorage.getItem('ndconml.tenant') ?? DEFAULT_TENANT,
    available: [] as TenantOption[] }),
  actions: {
    select(tenantId: string) {
      if (!/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(tenantId)) {
        throw new Error('Invalid tenant UUID')
      }
      this.tenantId = tenantId
      localStorage.setItem('ndconml.tenant', tenantId)
    },
    synchronize(tenants: TenantOption[], serverTenantId?: string | null) {
      this.available = tenants
      if (tenants.length === 0) return
      const selected = tenants.some(tenant => tenant.id === this.tenantId) ? this.tenantId
        : tenants.find(tenant => tenant.id === serverTenantId)?.id ?? tenants[0]!.id
      this.select(selected)
    }
  }
})
